import React, { Component } from "react";

class Footer extends Component {

    constructor() {
        super();
        this.state = {
            isTermsOfService: false,
            isPrivacyPolicy: false,
            isCookiePolicy: false,
            scriptLoaded: false,
        }
    }
    componentDidMount() {


    }
    loadTermlyScript = () => {
        const existingScript = document.getElementById("termly-jssdk");
        if (existingScript) {
            existingScript.remove();
        }

        const script = document.createElement("script");
        script.id = "termly-jssdk";
        script.src = "https://app.termly.io/embed-policy.min.js";
        script.type = "text/javascript";
        script.async = true;
        script.onload = () => {
            console.log("Termly script loaded");
        };

        document.body.appendChild(script);
        // this.state.scriptLoaded = true;
        // this.setState(this.state);
    };

    hanldeTermsOfService = () => {
        this.setState({ scriptLoaded: true, isTermsOfService: true }, () => {
            document.body.style.overflow = "auto";
            this.loadTermlyScript();
        });
    };

    closeTermsOfService = () => {
        this.setState({ isTermsOfService: false }, () => {
        });
    };

    hanldePrivacyPolicy = () => {
        this.setState({ isPrivacyPolicy: true }, () => {
            document.body.style.overflow = "auto";
            this.loadTermlyScript();
        });
    };

    closePrivacyPolicy = () => {
        this.setState({ isPrivacyPolicy: false }, () => {
        });
    };

    hanldeCookiePolicy = () => {
        this.setState({ isCookiePolicy: true }, () => {
            document.body.style.overflow = "auto";
            this.loadTermlyScript();
        });
    };

    closeCookiePolicy = () => {
        this.setState({ isCookiePolicy: false }, () => {
        });
    };


    render() {

        return (

            <div style={{
                display: "flex",
                justifyContent: "center",
            }}>
                <div style={{ height: "5vh" }} />

                {this.state.isTermsOfService && (
                    <div
                        style={{
                            position: "fixed",
                            // top: 0,
                            // left: 0,
                            bottom: "40vh",
                            width: "80vw",
                            maxHeight: "80vh",
                            backgroundColor: "rgba(0, 0, 0, 0.5)",
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                            zIndex: 1000,

                        }}
                    >
                        <div
                            style={{
                                position: "fixed",
                                backgroundColor: "white",
                                borderRadius: "8px",
                                boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
                                padding: "20px",
                                width: "70vw",
                                minHeight: "80vh",
                                maxHeight: "80vh",
                                overflowY: "auto",
                                display: "flex",
                                flexDirection: "column",
                            }}
                        >
                            {/* Close Button */}
                            <button
                                style={{
                                    position: "fixed",
                                    top: "12vh",
                                    right: "17vw",
                                    background: "red",
                                    color: "white",
                                    border: "none",
                                    fontSize: "18px",
                                    fontWeight: "bold",
                                    cursor: "pointer",
                                    padding: "5px 10px",
                                    borderRadius: "50%",
                                }}
                                onClick={this.closeTermsOfService}
                            >
                                ✖
                            </button>

                            <div
                                name="termly-embed"
                                data-id="bb8b6a76-aa10-4db4-9fdf-6c1e4c619e5b"
                                style={{
                                    padding: "35px",
                                }}
                            ></div>
                        </div>
                    </div>
                )}





                {this.state.isPrivacyPolicy && (
                    <div
                        style={{
                            position: "fixed",
                            top: 0,
                            left: 0,
                            width: "100%",
                            height: "100%",
                            backgroundColor: "rgba(0, 0, 0, 0.5)", // ✅ Dark overlay background
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                            zIndex: 1000,

                        }}
                    >
                        <div
                            style={{
                                position: "fixed",
                                backgroundColor: "white",
                                borderRadius: "8px",
                                boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
                                padding: "20px",
                                width: "70vw",
                                minHeight: "80vh",
                                maxHeight: "80vh",
                                overflowY: "auto",
                                display: "flex",
                                flexDirection: "column",
                            }}
                        >
                            {/* Close Button */}
                            <button
                                style={{
                                    position: "fixed",
                                    top: "12vh",
                                    right: "17vw",
                                    background: "red",
                                    color: "white",
                                    border: "none",
                                    fontSize: "18px",
                                    fontWeight: "bold",
                                    cursor: "pointer",
                                    padding: "5px 10px",
                                    borderRadius: "50%",
                                }}
                                onClick={this.closePrivacyPolicy}
                            >
                                ✖
                            </button>

                            <div
                                name="termly-embed"
                                data-id="7e31e177-92e6-4e28-8cd8-71c35aa3000a"
                                style={{
                                    padding: "35px",
                                }}
                            ></div>
                        </div>
                    </div>
                )}

                {this.state.isCookiePolicy && (
                    <div
                        style={{
                            position: "fixed",
                            top: 0,
                            left: 0,
                            width: "100%",
                            height: "100%",
                            backgroundColor: "rgba(0, 0, 0, 0.5)",
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                            zIndex: 1000,

                        }}
                    >
                        <div
                            style={{
                                position: "fixed",
                                backgroundColor: "white",
                                borderRadius: "8px",
                                boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
                                padding: "20px",
                                width: "70vw",
                                minHeight: "80vh",
                                maxHeight: "80vh",
                                overflowY: "auto",
                                display: "flex",
                                flexDirection: "column",
                            }}
                        >
                            {/* Close Button */}
                            <button
                                style={{
                                    position: "fixed",
                                    top: "12vh",
                                    right: "17vw",
                                    background: "red",
                                    color: "white",
                                    border: "none",
                                    fontSize: "18px",
                                    fontWeight: "bold",
                                    cursor: "pointer",
                                    padding: "5px 10px",
                                    borderRadius: "50%",
                                }}
                                onClick={this.closeCookiePolicy}
                            >
                                ✖
                            </button>

                            <div
                                name="termly-embed"
                                data-id="85ec2b84-5b92-490c-b0e4-11256dda37fc"
                                style={{
                                    padding: "35px",
                                }}
                            ></div>
                        </div>
                    </div>
                )}


                <footer style={styles.footer}
                    className=" bg-white navbar-light"
                >
                    <ul style={styles.links}>
                        <p style={styles.text}>
                            © 2022 - 2026 JEEVA Care, Inc. All rights reserved
                        </p>
                        <li>
                            <a
                                style={styles.link}
                                onClick={this.hanldeTermsOfService}
                            >Terms of Service
                            </a>
                        </li>
                        <li>
                            <a style={styles.link}
                                onClick={this.hanldePrivacyPolicy}
                            >Privacy Policy</a>
                        </li>
                        <li>
                            <a
                                onClick={this.hanldeCookiePolicy}
                                style={styles.link}>
                                Cookie Policy
                            </a>
                        </li>
                    </ul>
                </footer>

            </div>


        );
    }
}

const styles = {
    footer: {
        color: "#282a65",
        textAlign: "center",
        padding: "10px",
        position: "fixed",
        bottom: 0,
        width: "100%",
    },
    text: {
        margin: 0,
        fontSize: "14px",
    },
    links: {
        listStyle: "none",
        padding: 0,
        margin: "10px 0 0",
        display: "flex",
        justifyContent: "center",
        gap: "70px",
        // fontWeight: "bold"
    },
    link: {
        color: "#282a65",
        fontSize: "14px",
        textDecoration: "none",
    },
};

export default Footer;



// WEBPACK FOOTER //
// src/my-jeeva/footer/Footer.js